import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=629abdf6&"
import script from "./Dash.vue?vue&type=script&lang=js&"
export * from "./Dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Users/patri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports